function initSwiper() {
  if (window.innerWidth < 750) {
    const bubblesSwiper = new Swiper('.js-bubbles-container', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },

      // on: {
      //   init: function () {
      //     console.log('Swiper initialized with spaceBetween:', this.params.spaceBetween);
      //   },
      // },
    });
  }
}

// Initialize Swiper on page load
initSwiper();

// Reinitialize on window resize
window.addEventListener('resize', function () {
  initSwiper();
});
